import Inputmask from "inputmask";
import MascaraCartaoCredito from "./mascara_cartao_credito";

export default class Mascaras {
  maskCpf = new Inputmask("999.999.999-99");
  maskCnpj = new Inputmask("99.999.999/9999-99");
  maskData = new Inputmask("99/99/9999");
  maskDataPtBr = new Inputmask("99/99/9999");
  maskDataEs = new Inputmask("99/99/9999");
  maskDataEn = new Inputmask("99/99/9999");
  maskTelefone = new Inputmask("(99)99999-9999");
  maskCep = new Inputmask("99.999-999");
  maskCurrency = new Inputmask("currency", {
    radixPoint: ",",
    // positionCaretOnClick: 'none',
    allowMinus: false,
    prefix: "R$",
  });
  maskCartaoCredito = new MascaraCartaoCredito();

  start = () => {
    this.maskCpf.mask($("input.mask-cpf"));
    this.maskCnpj.mask($("input.mask-cnpj"));

    this.maskCurrency.mask($("input.mask-currency"));

    this.maskData.mask($("input.mask-data"));

    this.maskDataPtBr.mask($("input.mask-data-pt-BR"));
    this.maskDataEn.mask($("input.mask-data-en"));
    this.maskDataEn.mask($("input.mask-data-es"));

    this.maskTelefone.mask($("input.mask-telefone"));
    this.maskCep.mask($("input.mask-cep"));
    this.maskCartaoCredito.aplicar($("input.mask-numero-cartao-credito"));
  };

  unmask = (input) => {
    Inputmask.remove(input);
  };
}
